import {
  GET_ALL_STUDENTS,
  GET_ALL_STUDENTS_SUCCESS,
  GET_ALL_STUDENTS_FAILURE,
  GET_ACTIVE_STUDENTS,
  GET_ACTIVE_STUDENTS_SUCCESS,
  GET_ACTIVE_STUDENTS_FAILURE,
  GET_STUDENTS_ANALYTICS,
  GET_STUDENTS_ANALYTICS_SUCCESS,
  GET_STUDENTS_ANALYTICS_FAILURE,
  GET_STUDENT_DETAILS,
  GET_STUDENT_DETAILS_SUCCESS,
  GET_STUDENT_DETAILS_FAILURE,
  UPDATE_STUDENT,
  UPDATE_STUDENT_SUCCESS,
  UPDATE_STUDENT_FAILURE,
} from "../constants";

const initialState = {
  activeStudents: [],
  students: [],
  studentsAnalytics: {},
  student: {},
  count: 0,
  isLoading: false,
  isAnalyticsLoading: false,
  isStudentLoading: false,
  error: null,
};

export default function StudentReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ACTIVE_STUDENTS:
    case GET_ALL_STUDENTS:
    case UPDATE_STUDENT:
      state = {
        ...state,
        isLoading: true,
        error: null,
      };
      break;
    case GET_STUDENTS_ANALYTICS:
      state = {
        ...state,
        isAnalyticsLoading: true,
        error: null,
      };
      break;
    case GET_STUDENT_DETAILS:
      state = {
        ...state,
        isStudentLoading: true,
        error: null,
      };
      break;
    case GET_ACTIVE_STUDENTS_SUCCESS:
      state = {
        ...state,
        activeStudents: action?.payload,
        isLoading: false,
      };
      break;
    case UPDATE_STUDENT_SUCCESS:
      state = {
        ...state,
        isLoading: false,
      };
      break;
    case GET_STUDENT_DETAILS_SUCCESS:
      state = {
        ...state,
        student: action?.payload,
        isStudentLoading: false,
      };
      break;
    case GET_STUDENTS_ANALYTICS_SUCCESS:
      state = {
        ...state,
        studentsAnalytics: action?.payload,
        isAnalyticsLoading: false,
      };
      break;
    case GET_ALL_STUDENTS_SUCCESS:
      state = {
        ...state,
        students: action?.payload?.students,
        count: action?.payload?.count,
        isLoading: false,
      };
      break;
    case GET_ACTIVE_STUDENTS_FAILURE:
    case GET_ALL_STUDENTS_FAILURE:
    case UPDATE_STUDENT_FAILURE:
      state = {
        ...state,
        isLoading: false,
        error: action.payload,
      };
      break;
    case GET_STUDENTS_ANALYTICS_FAILURE:
      state = {
        ...state,
        isAnalyticsLoading: false,
        error: action.payload,
      };
      break;
    case GET_STUDENT_DETAILS_FAILURE:
      state = {
        ...state,
        isStudentLoading: false,
        error: action.payload,
      };
      break;
    default:
      break;
  }
  return state;
}
